document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.js-description-wrapper');
  const btn = document.querySelector('.js-read-more-btn');
  
  if (wrapper && btn) {
    // Only show button if content is taller than the limit (650px)
    if (wrapper.scrollHeight <= 650) {
      btn.style.display = 'none';
      const fade = wrapper.querySelector('.description-fade');
      if (fade) fade.style.display = 'none';
    }

    btn.addEventListener('click', function() {
      const isExpanded = wrapper.classList.toggle('is-expanded');
      btn.textContent = isExpanded ? 'Read Less' : 'Read More';
    });

    // Hide any headings/text that mention "Bestseller" (usually table headings)
    const allElements = wrapper.querySelectorAll('h1, h2, h3, h4, h5, h6, p, strong');
    allElements.forEach(el => {
      if (el.textContent.includes('Bestseller')) {
        el.style.display = 'none';
      }
    });
  }
});
